
import { useContext} from 'react';
import ProfileTopNavigation from './ProfileTopNavigation';
import { ProfileSliderContext } from '../../appContext';
import AppointmentHistorySection from '../../PageComponent/ProfilePage/AppointmentHistorySection';
function AppointmentHistory() {
    const { handelViewRequestBlock } = useContext(ProfileSliderContext);
    const handleClick = (data, proData) => {
    handelViewRequestBlock(data, proData); // this will open the ConsultationViewRequest
  };
  return (
   
    <>
     <ProfileTopNavigation pageTitle={'Appointment History'} />
     <AppointmentHistorySection
     handleviewreqdesktop={(data, profileData)=>{handleClick(data, profileData)}}
     />
    </>
  );
}

export default AppointmentHistory;
